import { List, type ListProps } from "shared/react";
import { useQuery } from "../util/db.js";
import { USER } from "../util/user.js";
import { LeaderboardButton } from "./LeaderboardButton.js";

/** Show a list of leaderboard buttons for any leaderboards this user has joined for a given challenge. */
export function ChallengeLeaderboardList({ cid, ...props }: { cid: string } & ListProps): React.ReactElement | null {
	return (
		<List //
			store={useQuery("leaderboard", { uid: USER.data.uid, cid: cid, tid: "a", $order: "!joined", $limit: 3 })}
			mapper={({ creator }) => <LeaderboardButton key={creator} cid={cid} creator={creator} />}
			{...props}
		/>
	);
}
